import { createTheme } from '@mui/material/styles';
import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['Open Sans'].join(','),
    },

    breakpoints: {
      values: {
        xs: 0,
        sm: 600, // Small screen / phone
        md: 920, // Medium screen / tablet
        lg: 1200, // Large screen / desktop
        xl: 1500,
      },
    },

    palette: {
      contrastThreshold: 3,
      primary: {
        main: '#205373',
        contrastText: '#fff',
      },
      secondary: {
        main: '#bf1f2c',
        contrastText: '#181c32',
      },
      error: {
        main: '#bf1f2c',
      },
      success: {
        main: '#6a96c3',
        contrastText: '#0c1514',
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */

    components: {
      // Name of the component ⚛️
      MuiTextField: {
        defaultProps: {
          variant: 'standard', // Sets the default type for all TextFields
        },
      },
    },
  }
);

export default function ThemeProviderMui(props: any) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
